module.exports = __webpack_public_path__ + "img/0c75222e8463b283c9b4e6364666b42f.png";